import { getTreeStructure } from '../treeStructure';
import { processObject } from '../function/CountMissingFieldByPage';
import ShowOptions from '../function/ShowOptions';

function GetAllPages(options, showOptions = 'all', svFamily = null) {
  let pages = [];
  const resolvedTreeStructure = getTreeStructure(svFamily);
  const optionsByField = new Map(
    options.map((option) => [option.field, option])
  );

  Object.keys(resolvedTreeStructure).forEach((group) => {
    Object.keys(resolvedTreeStructure[group]).forEach((page) => {
      if (options.length === 0) pages.push(page);
      else {
        const itemList = processObject(resolvedTreeStructure[group][page]);
        const usedItem = itemList.filter((item) => {
          const option = optionsByField.get(item);
          return option && ShowOptions(option, showOptions);
        });
        if (usedItem.length > 0) pages.push(page);
      }
    });
  });
  return pages;
}

export default GetAllPages;
